import { type FC } from 'react';

import {
  type DynamicModalProps,
  type ModalKeyNameType,
} from '@/common/types/modal';
import { BuyPlusContract } from '@/components/Contract/BuyPlusContract/BuyPlusContract';
import { ProductOfDayOffersModal } from '@/components/ProductOfDayOffer/ProductOfDayOffersModal/ProductOfDayOffersModal';

const componentsMap = {
  buyPlusContract: BuyPlusContract,
  productOfDayOffers: ProductOfDayOffersModal,
} satisfies { [K in ModalKeyNameType]: FC<DynamicModalProps[K]> };

export { componentsMap };
